<template>
	<div class="dashboard-container">
		<div class="title" style="margin-bottom: 15px;">问题反馈</div>
		<el-tabs type="border-card" v-model="activeName">
			<el-tab-pane name="one" label="问题反馈">
				<div class="screen" style="margin-bottom: 15px;">
					<el-date-picker v-model="filter1.time" type="daterange" value-format="yyyy-MM-dd"
						@change="getlist()" range-separator="至" size="small" placeholder="选择日期" start-placeholder="开始日期"
						end-placeholder="结束日期" style="margin-left: 10px;width: 300px;">
					</el-date-picker>
					<el-select clearable filterable size="small" v-model="filter1.type" @change="getlist()"
						style="width:120px;margin-left:10px;" placeholder="问题类型">
						<el-option v-for="item in type3" :key="item.key" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-select clearable filterable size="small" v-model="filter1.status" @change="getlist()"
						style="width:130px;margin-left:10px;" placeholder="全部状态">
						<el-option v-for="item in status1" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
					<el-select clearable v-model="filter1.like" style="width: 150px;margin-left: 10px;" size="small">
						<el-option v-for="item in keys1" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-input clearable type="text" style="width: 250px;margin-right: 10px;" size="small"
						v-model="filter1.text" @keydown.enter.native="getlist()">
					</el-input>
					<el-button size="small" type="primary" @click="getlist()">筛选</el-button>
					<el-button @click="clear1()" size="small" style="margin-left: 10px;">重置</el-button>
				</div>
				<el-table :data="tableData1" style="width: 100%" v-loading="loading"
					:header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
					:cell-style="{'text-align': 'center', 'font-size': '14px'}">
					<el-table-column prop="type" label="问题类型" width="120px">
						<template slot-scope="scope">
							{{ scope.row.type | typeFormat1 }}
						</template>
					</el-table-column>
					<el-table-column prop="telphone" label="用户手机号" width="120px"></el-table-column>
					<el-table-column prop="name" label="发型师名称" width="100px">
						<template slot-scope="scope">
							{{scope.row.name==null? "/" : scope.row.name}}
						</template>
					</el-table-column>
					<el-table-column prop="storeName" label="店铺" width="150px">
						<template slot-scope="scope">
							{{scope.row.storeName==null? "/" : scope.row.storeName}}
						</template>
					</el-table-column>
					<el-table-column prop="addTime" label="反馈提交时间" width="200px"></el-table-column>
					<el-table-column label="具体事由">
						<template slot-scope="scope">
							{{scope.row.content}}
						</template>
					</el-table-column>
					<el-table-column width="150" label="操作">
						<template slot-scope="scope">
							<div class="flex">
								<div>
									<el-image-viewer v-if="showViewer1" :on-close="closeViewer"
										:url-list="[ scope.row.morningImg,scope.row.nightImg]" />
									<el-button type="text" @click="onPreview(scope.row.id)">详情</el-button>
									<el-button type="text" @click="off1(scope.row.id,scope.row.status)"
										:class="scope.row.status==1?'':'red'">
										{{ scope.row.status==1?'已处理':'待处理' }}
									</el-button>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagechange">
					<el-pagination class="pages" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="filter1.pageNum" :page-sizes="[10,20,50]" :page-size="filter1.pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="filter1.total">
					</el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane name="two" label="订单报错">
				<div class="screen" style="margin-bottom: 15px;">
					<el-date-picker @change="getlist()" v-model="filter2.time" type="daterange"
						value-format="yyyy-MM-dd" range-separator="至" size="small" placeholder="选择日期"
						start-placeholder="开始日期" end-placeholder="结束日期" style="margin-left: 10px;width: 300px;">
					</el-date-picker>
					<el-select clearable filterable size="small" v-model="filter2.type" @change="getlist()"
						style="width:120px;margin-left:10px;" placeholder="问题类型">
						<el-option v-for="item in type4" :key="item.key" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-select clearable filterable size="small" v-model="filter2.status" @change="getlist()"
						style="width:130px;margin-left:10px;" placeholder="全部状态">
						<el-option v-for="item in status1" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
					<el-select clearable v-model="filter2.like" style="width: 150px;margin-left: 10px;" size="small">
						<el-option v-for="item in keys" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-input clearable type="text" style="width: 250px;margin-right: 10px;" size="small"
						v-model="filter2.text" @keydown.enter.native="getlist()">
					</el-input>
					<el-button size="small" type="primary" @click="getlist()">筛选</el-button>
					<el-button @click="clear2()" size="small" style="margin-left: 10px;">重置</el-button>
				</div>
				<el-table :data="tableData2" style="width: 100%" v-loading="loading"
					:header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
					:cell-style="{'text-align': 'center', 'font-size': '14px'}">
					<el-table-column prop="orderId" label="订单号" width="100px"></el-table-column>
					<el-table-column prop="userId" label="用户ID" width="100px"></el-table-column>
					<el-table-column label="用户手机号" width="120px">
						<template slot-scope="scope">
							{{scope.row.telphone==null? "/" : scope.row.telphone}}
						</template>
					</el-table-column>
					<el-table-column prop="nickName" label="用户昵称" width="100px"></el-table-column>
					<el-table-column prop="orderType" label="购买服务" width="120px"></el-table-column>
					<el-table-column label="店铺" width="100px">
						<template slot-scope="scope">
							{{scope.row.storeName==null? "/" : scope.row.storeName}}
						</template>
					</el-table-column>
					<el-table-column label="发型师名称" width="100px">
						<template slot-scope="scope">
							{{scope.row.workerName==null? "/" : scope.row.workerName}}
						</template>
					</el-table-column>
					<el-table-column prop="type" label="问题类型" width="120px">
						<template slot-scope="scope">
							{{ scope.row.type | typeFormat }}
						</template>
					</el-table-column>
					<el-table-column prop="content" label="具体事由"></el-table-column>
					<el-table-column prop="addTime" label="报错提交时间" width="200px"></el-table-column>
					<el-table-column width="150" label="操作">
						<template slot-scope="scope">
							<div class="flex">
								<el-image-viewer v-if="showViewer" :on-close="closeViewer"
									:url-list="[scope.row.img]" />
								<el-button type="text" @click="onPreview(scope.row.id)">详情</el-button>
								<el-button type="text" :class="scope.row.status==1?'':'red'"
									@click="off(scope.row.id,scope.row.status)">
									{{ scope.row.status==1?'已处理':'待处理' }}
								</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagechange">
					<el-pagination class="pages" @size-change="handleSizeChange01"
						@current-change="handleCurrentChange01" :current-page="filter2.pageNum" :page-sizes="[10,20,50]"
						:page-size="filter2.pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="filter2.total">
					</el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane name="three" label="防疫反馈">
				<div>
					<!-- <div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">发型师管理>疫情申报</div> -->
					<div class="title">
						<!-- <div class="blue"></div> -->
						<div style="flex: 1;">疫情申报</div>
						<router-link to="/">
							<el-button type="primary" style="margin: 10px;" @click="getCovidExpor">导出</el-button>
						</router-link>
					</div>
					<!-- <div class="right"> -->
					<!-- 	<router-link to="/">
							<el-button type="primary" style="margin: 10px;" @click="getCovidExpor">导出</el-button>
						</router-link> -->
					<!-- </div> -->
					<div>
						<el-table :data="tableData3" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
							style="width: 100%">
							<el-table-column prop="workerName" label="申报发型师姓名" align="center"></el-table-column>
							<el-table-column prop="storeName" label="所在门店" align="center"></el-table-column>
							<el-table-column prop="time" label="最近服务时间" align="center"></el-table-column>
							<el-table-column prop="reason" label="申报理由" align="center"></el-table-column>
							<el-table-column prop="telephone" label="申报用户手机号" align="center"></el-table-column>
						</el-table>
					</div>
					<div class="pagescg">
						<el-pagination @size-change="handleSizeChange03" @current-change="handleCurrentChange03"
							:current-page="filter2.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
							layout=" sizes, prev, pager, next, jumper" :total="filter2.total" align="center">
						</el-pagination>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
	import {
		url
	} from '../../utils/index.js'
	import upload from '../compents/upload/upload'
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
	export default {
		components: {
			upload,
			ElImageViewer
		},
		data() {
			return {
				url: url(),
				list: [],
				oplist: [],
				relist: [],
				loading: false,
				// 门店列表
				storelist: [],
				storesEnd: [],
				showViewer1: false,
				showViewer: false,
				shows: {},
				filter1: {
					id: "",
					status: '',
					type: "",
					like: "",
					text: "",
					time: [], //时间
					total: 0, //页面总数1
					date: [],
					startTime: "",
					endTime: "",
					pageNum: 1, //页码
					pageSize: 10, // 条数
				},
				filter2: {
					id: "",
					status: '',
					type: "",
					like: "",
					text: "",
					time: [], //时间
					total: 0, //页面总数1
					date: [],
					startTime: "",
					endTime: "",
					pageNum: 1, //页码
					pageSize: 10, // 条数
				},
				filter3: {
					pageNum: 1, //页码
					pageSize: 10, // 条数
				},
				// dialogVisible1: false,
				// dialogVisible: false, //用户打开弹出框
				data: '',
				//判断弹出框里面的保存按钮是否显示
				// parsershow: "",
				imgurl: "",
				activeName: 'one',
				tableData1: [],
				tableData2: [],
				tableData3: [],
				add: false, //刷评价弹窗
				status1: [{
					value: 1,
					label: '已处理'
				}, {
					value: 0,
					label: '未处理'
				}],
				type3: [{
					value: "1",
					label: "支付问题"
				}, {
					value: "2",
					label: "会员/套餐问题"
				}, {
					value: "3",
					label: "充值问题"
				}, {
					value: "4",
					label: "其他问题"
				}],
				type4: [{
					value: "1",
					label: "支付问题"
				}, {
					value: "2",
					label: "会员/套餐问题"
				}, {
					value: "3",
					label: "抖音问题"
				}, {
					value: "4",
					label: "其他问题"
				}],
				keys1: [{
						value: "1",
						label: "手机号"
					}, {
						value: "2",
						label: "发型师名称"
					}
					// ,
					// {
					// 	value: "3",
					// 	label: "购买服务"
					// }
				],
				keys: [{
					value: "1",
					label: "用户ID"
				}, {
					value: "2",
					label: "用户手机号"
				}, {
					value: "3",
					label: "用户昵称"
				}, {
					value: "4",
					label: "购买服务"
				}],
			}
		},
		watch: {
			activeName(val, oldVal) { //普通的watch监听

				this.getlist()
			},
		},
		filters: {
			typeFormat1(val) {
				switch (val) {
					case 1:
						return "支付问题";
					case 2:
						return "会员/套餐问题";
					case 3:
						return "充值问题";
					case 4:
						return "其他问题";
					default:
						return "/";
				}
			},
			typeFormat(val) {
				switch (val) {
					case 1:
						return "支付问题";
					case 2:
						return "会员/套餐问题";
					case 3:
						return "抖音问题";
					case 4:
						return "其他问题";
					default:
						return "/";
				}
			},
		},
		mounted() {
			this.getlist()
			this.getstore()
		},
		methods: {
			//重置意见筛选
			clear1() {
				this.filter1 = {
					text: "",
					time: "", //时间
					type: "", //发型师
					status: "",
					total: 0, //页面总数1
					startTime: "",
					endTime: "",
					pageNum: 1, //页码
					pageSize: 10, // 条数
				}
				this.getlist()
			},
			// 重置评价筛选
			clear2() {
				this.filter2 = {
					text: "",
					time: "", //时间
					type: "", //发型师
					status: "",
					total: 0, //页面总数1
					startTime: "",
					endTime: "",
					pageNum: 1, //页码
					pageSize: 10, // 条数
				}
				this.getlist()
			},
			// 下架
			off1(id, status) {
				let arr = {
					id: id,
					status: status == 1 ? 0 : 1
				}
				this.$http.post("dQuestionFeedback/save", JSON.stringify(arr)).then((res) => {
					if (res.body.code == "200") {
						if (arr.status == 1) this.$message.success("已处理")
						if (arr.status == 0) this.$message.success("撤销处理")
						this.getlist()
					}
				})
			},
			// 下架
			off(id, status) {
				let arr = {
					id: id,
					status: status == 1 ? 0 : 1
				}
				this.$http.post("dOrderReport/save", JSON.stringify(arr)).then((res) => {
					if (res.body.code == "200") {
						if (arr.status == 1) this.$message.success("已处理")
						if (arr.status == 0) this.$message.success("撤销处理")
						this.getlist()
					}
				})
			},
			//获取所有门店
			getstore() {
				this.$http.get("store/list?").then(function(res) {
					// res.body.data.rows = res.body.data.rows.filter(ele => ele.businessType == 0)
					if (res.body.code == "200") {
						res.body.data.forEach(ele => {
							if (ele.businessType == 1) {
								this.storesEnd.push(ele) //结业门店
							} else {
								this.storelist.push(ele) //营业门店
							}
						})
					}
				})
			},
			getlist() {
				// 查找问题反馈列表
				if (this.activeName == "one") {
					// if (this.filter1.time != '' && this.filter1.time != null) {
					// 	this.filter1.startTime = this.filter1.time[0]
					// 	this.filter1.endTime = this.filter1.time[1]
					// 	console.log(this.filter1.startTime)
					// }
					var a = {
						// startTime: this.filter1.startTime,
						// endTime: this.filter1.endTime,
						page: this.filter1.pageNum - 1,
						size: this.filter1.pageSize,
						like: this.filter1.like,
						text: this.filter1.text,
						type: this.filter1.type
					}
					if (this.filter1.time != '' && this.filter1.time != null) {
						a.startTime = this.filter1.time[0]
						a.endTime = this.filter1.time[1]
					}
					if (this.filter1.status != null)
						a.status = this.filter1.status
					if (a.type == null || a.type == '')
						delete a.type
					if (a.text == null || a.text == '') {
						delete a.like
						delete a.text
					}
					console.log(this.filter1.endTime)
					this.$http.get("dQuestionFeedback/findQuestionFeedback", {
						params: a
					}, {
						emulateJSON: true
					}).then(function(res) {
						console.log(res)
						if (res.body.code == "200") {
							this.tableData1 = res.body.data;
							this.filter1.total = res.body.total;
							console.log(this.tableData1)
						}
					})
				}
				// 查找订单报错列表
				if (this.activeName == "two") {
					// if (this.filter2.time != '' && this.filter2.time != null) {
					// 	this.filter2.startTime = this.filter2.time[0]
					// 	this.filter2.endTime = this.filter2.time[1]
					// 	console.log(this.filter2.startTime)
					// }
					var b = {
						orderId: this.filter2.orderId,
						// startTime: this.filter2.startTime,
						// endTime: this.filter2.endTime,
						page: this.filter2.pageNum - 1,
						size: this.filter2.pageSize,
						like: this.filter2.like,
						text: this.filter2.text,
						type: this.filter2.type
					}
					if (b.orderId == null || b.orderId == '')
						delete b.orderId
					if (this.filter2.time != '' && this.filter2.time != null) {
						b.startTime = this.filter2.time[0]
						b.endTime = this.filter2.time[1]
					}
					if (this.filter2.status != null)
						b.status = this.filter2.status
					if (b.type == null || b.type == '')
						delete b.type
					if (b.text == null || b.text == '') {
						delete b.like
						delete b.text
					}
					console.log(b)
					this.$http.get("dOrderReport/findOrderReport", {
						params: b
					}, {
						emulateJSON: true
					}).then(function(res) {
						console.log(res)
						if (res.body.code == "200") {
							this.tableData2 = res.body.data;
							this.filter2.total = res.body.total;
							console.log(this.tableData2)
						}
					})
				}
				if (this.activeName == "three") {
					let q = {
						pageSize: this.filter3.pageSize,
						pageNum: this.filter3.pageNum
					}
					this.$http.post("dWorker/covidUpload", JSON.stringify(q)).then(function(res) {
						this.tableData3 = res.body.data;
						this.filter3.total = res.body.total;
					}, function(err) {
						this.$message.error("请求失败");
					})
				}
			},
			getCovidExpor() {
				window.location.assign(this.url + "dWorker/covidUploadExpor");
			},
			onPreview(id) {
				if (this.activeName == "one") {
					this.showViewer1 = true
				}
				if (this.activeName == "two") {
					this.showViewer = true
				}
				if (this.activeName == "three") {
					this.showViewer = true
				}
			},
			closeViewer() {
				if (this.activeName == "one") {
					this.showViewer1 = false
				}
				if (this.activeName == "two") {
					this.showViewer = false
				}
				if (this.activeName == "three") {
					this.showViewer = false
				}
				// this.showViewer = false
			},
			handleClick(tab, event) {
				console.log(tab, event)
			},
			handleSizeChange(val) {
				this.filter1.pageSize = val
			},
			handleCurrentChange(val) {
				this.filter1.pageNum = val
			},
			handleSizeChange01(val) {
				this.filter2.pageSize = val
			},
			handleCurrentChange01(val) {
				this.filter2.pageNum = val
			},
			handleSizeChange03(val) {
				this.filter3.pageSize = val;
			},
			handleCurrentChange03(val) {
				this.filter3.pageNum = val;
			},
		}
	}
</script>

<style scoped="scoped" lang="less">
	.red {
		color: red;
	}

	.dashboard-container {
		box-sizing: border-box;

		.title {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #3e3e3e;
			margin-bottom: 0px;
			margin-top: 0px;
		}

		.pagechange {
			margin-top: 20px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
		}
	}
</style>